// "Sold through Falcon CRM" in Falcon PLM: on a garment's Details tab and a PO's Items tab, the quantities sales have sold
// (from stock and as pre-orders against the PO) and what is left to pre-sell. Quantities only: no customer prices.
import { esc, formatDate, get } from "../lib.js";
import { state } from "../state.js";

const qty = (n: number) => Math.round(n).toLocaleString("en-GB");
const on = () => !!state.session.organisation?.crmPlmLink;

function presellTable(rows: any[], showCode: boolean): string {
  if (!rows.length) return "";
  return `<div class="table-wrap"><table class="crm-mini-table crm-sold-table"><thead><tr>${showCode ? "<th>Garment</th>" : "<th>PO</th>"}<th>Colour</th><th>Lands</th><th class="num">On order</th><th class="num">Pre-sold</th><th class="num">Left to pre-sell</th></tr></thead><tbody>
${rows.map((r) => `<tr><td>${esc(showCode ? r.code : r.poNumber)}</td><td>${esc(r.colour || "—")}</td><td>${esc(r.eta ? formatDate(r.eta) : "—")}</td><td class="num">${qty(r.onOrderTotal)}</td><td class="num">${qty(r.soldTotal)}</td><td class="num ${r.leftTotal < 0 ? "crm-overdue" : ""}">${qty(r.leftTotal)}</td></tr>`).join("")}</tbody></table></div>`;
}

/** A garment: what Falcon CRM has sold, by colour, and its open POs' pre-sales. */
export async function crmSoldItem(box: HTMLElement | null, itemId: string) {
  if (!box || !on()) return;
  try {
    const d = await get<any>(`/api/org/items/${itemId}/crm-sold`);
    if (!d.enabled || (!d.colours.length && !d.preorders.some((p: any) => p.soldTotal))) return;
    box.hidden = false;
    box.innerHTML = `<div class="panel-head"><div><h3>Sold through Falcon CRM</h3><span class="muted">${d.orders} sales order${d.orders === 1 ? "" : "s"} · quantities only</span></div></div>
${d.colours.length ? `<div class="table-wrap"><table class="crm-mini-table crm-sold-table"><thead><tr><th>Colour</th><th class="num">From stock</th><th class="num">Pre-order</th><th class="num">Total</th><th class="num">Delivered</th><th>By size</th></tr></thead><tbody>
${d.colours.map((c: any) => `<tr><td>${esc(c.colour)}</td><td class="num">${qty(c.stock)}</td><td class="num">${qty(c.preorder)}</td><td class="num"><strong>${qty(c.total)}</strong></td><td class="num">${qty(c.delivered)}</td><td>${esc(c.sizesText || "—")}</td></tr>`).join("")}</tbody></table></div>` : ""}
${presellTable(d.preorders, false)}`;
  } catch { /* not for this person */ }
}

/** A PO: each garment line's pre-sales and what is left to pre-sell. */
export async function crmSoldPo(box: HTMLElement | null, poId: string) {
  if (!box || !on()) return;
  try {
    const d = await get<any>(`/api/org/pos/${poId}/crm-sold`);
    if (!d.enabled || !d.lines.some((l: any) => l.soldTotal)) return;
    box.hidden = false;
    box.innerHTML = `<h4>Sold through Falcon CRM</h4><p class="muted">Pre-orders sales have taken against this PO (${d.orders} sales order${d.orders === 1 ? "" : "s"}). Quantities only.</p>${presellTable(d.lines, true)}`;
  } catch { /* not for this person */ }
}
